export interface ErrorToasterState{
    activeToast: boolean,
    message: string
}

export const state: ErrorToasterState = {
    activeToast: false,
    message: '',
};